import { Stack, StackProps } from '@mui/material'

import { FCWithChildren } from '@/types'

import { PADDING_X } from '@/constants'

const Container: FCWithChildren<StackProps> = ({ children, sx, ...props }) => {
  return (
    <Stack sx={{ px: PADDING_X, ...sx }} {...props}>
      {children}
    </Stack>
  )
}

export default Container
